export const projectTextRecogData = {
    title: 'Text Recognition',
    overview_title:'Overview',
    overview: 'This project aims at digitizing texts. With our project we aim to convert the images of different types (Printed, Handwritten or scanned text images) into an editable digital format for deeper and further processing. In this project we have dealt with an image of a single line of text as input , then infer the text written in the image and finally return the text as output.',
    technical_title: 'Technologies',
    technical: 'Language: Python,  Libraries: Tensorflow,  Dev Tool: Google collab ,  Algorithms: CNN and RNN',
    features_title:'Features and Functionality',
    features: [
        'Deep learning model created.',
        'Different models are trained.',
        'Character Error Rate and Word Error Rate are monitored and tried to minimize them.'
    ]
};

export const projectCityEventData = {
    title:'City Event',
    overview_title: 'Overview',
    technical_title: 'Technologies',
    features_title:'Features and Functionality',
    overview_content:'This is event hosting mobile application that empowers users to effortlessly create, host, and oversee their events, while also providing them with the convenience of exploring events organized by other users. The app offers a comprehensive platform for both event organizers and attendees to discover and engage with various events in an efficient and enjoyable manner.',
    technical_content:'Language: Java,  Database: Firebase,  Dev Tool: Android Studio',
    features_content: [
        'Users can create and host events with relevant details like event title, image, description, date, time, location, category etc',
        'Events can be filtered based on proximity to the user\'s location and categories.',
        'Map mode is available where user can veiw locations of all event near user in map.'
    ]
}

export const projectIntercodeData = {
    title:'Intercode',
    overview_title: 'Overview',
    technical_title: 'Technologies',
    features_title:'Features and Functionality',
    overview_content:'The Coding Interview desktop application that facilitates coding interviews between interviewees and interviewers. With this platform, both parties can collaborate on a shared code editor, enabling real-time edits and communication through an integrated chat system. To enhance the interview experience, a timer functionality allows the interviewer to set time limits for each question.',
    technical_content:'Language: Java,  Database: Firebase,  Tech: Socket-Programming',
    features_content:[
        'Both interviewees and interviewers can write, edit, and execute code in real-time using a shared code editor',
        'The platform includes a built-in chat system that allows interviewees and interviewers to communicate, exchange questions, and clarify doubts',
        'Interviewers can register students by capturing their details and generating unique usernames and passwords. Students can use these credentials to securely access their interviews',
        
    ]
}